import { map } from "lodash";

export const getPlaylistUpdatePayload = (data) => {
  const { name, songs } = data;
  return {
    name,
    songs: map(songs, (song, i) => {
      return song?.id;
    }),
  };
};
export const rearrangeLiked = (arr) => {
  let liked = [];
  let notLiked = [];
  arr.forEach((item) => {
    if (item.is_favourite) {
      liked.push(item);
    } else {
      notLiked.push(item);
    }
  });
  return [...liked, ...notLiked];
};
